export default __webpack_public_path__ + "static/media/downarrow_dim.95d14b94.svg";